import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import MuiTableCell from "@material-ui/core/TableCell";
import MuiTableHead from "@mui/material/TableHead";
import Tooltip from "@mui/material/Tooltip";
import { CustomButton } from "../../components/Common/CustomButton";
import { renderWithCommand } from "../../helpers";
import moment from "moment";
import axiosInstance from "../../components/axiosApi";


const useStyles = makeStyles((theme) => ({
  tableBorder: {
    border: "1px solid #d4d8dd",
    borderRadius: "0.5rem",
  },
  btnGlobal: {
    minWidth: "inherit",
    width: 28,
    padding: "0",
    height: "28px",
    lineHeight: "28px",

    marginLeft: 5,
    boxShadow: "none",
    fontSize: "12px",
    fontWeight: "500",
  },
  btnBlue: { backgroundColor: "#556ee6" },
  // btnGreen:{
  //   backgroundColor: '#34c38f',
  // },
  btnYellow: {
    backgroundColor: "#f1b44c",
  },
  btnRed: {
    backgroundColor: "#f46a6a",
  },
}));

const TableCell = withStyles({
  root: {
    borderBottom: "1px solid rgb(235, 237, 242)",
    padding: "10px",
    lineHeight: "18px",
  },
})(MuiTableCell);

const TableHead = withStyles((theme) => ({
  root: {
    backgroundColor: "rgba(38,60,85,.1)",
  },
}))(MuiTableHead);

const TableHeaderCell = withStyles((theme) => ({
  root: {
    color: "#516377",
    fontWeight: 700,
    padding: "10px",
    fontSize: ".75rem",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    lineHeight: "18px",
  },
}))(TableCell);

const TicketCustomer = ({dataCustomers,setDetailCustomer}) => {
    console.log(dataCustomers)
    const classes = useStyles();
    const [rows, setRows] = React.useState();


    const handleShowDetail = async (data) => {
      try {
        const res = await axiosInstance.get(`/leads/${data.id}/`);
        if (res.status === 200) 
        setDetailCustomer(res.data);
        
       
      } catch (error) {
        setDetailCustomer({});
      }
    };

    useEffect(() => {
        if (dataCustomers?.open_leads?.open_leads) {
          setRows([...dataCustomers?.open_leads?.open_leads]);
        }
      }, [dataCustomers?.open_leads]);
  return (
    <>
        {dataCustomers?.open_leads?.open_leads.length > 0 ? (
        <Paper
          sx={{ width: "100%", mb: 2 }}
          elevation={0}
          className={`${classes.tableBorder}`}
        >
          <div
        className="ul-heading"
        style={{ padding: '8px', display: "flex", alignItems: "center", marginBottom:'0px',flexWrap:'wrap' }}
      >
        <span >Danh sách đơn hàng</span>
      </div>
          <TableContainer
            style={{
              width: "100%",
              overflowX: "auto",
              borderRadius: "0.5rem",
            }}
          >
            <Table sx={{ minWidth: 700 }} size={"small"}>
              <TableHead>
                <TableRow>
                <TableHeaderCell align="left" style={{ minWidth: 40 }}>
                   STT
                  </TableHeaderCell>
                  <TableHeaderCell align="left" style={{ width: 120 }}>
                  SĐT
                  </TableHeaderCell>

                  <TableHeaderCell align="left" style={{ minWidth: 40 }}>
                  TÊN KHÁCH HÀNG	
                  </TableHeaderCell>

                  <TableHeaderCell align="left" style={{ minWidth: 60 }}>
                  NHÂN VIÊN CHĂM SÓC	
                  </TableHeaderCell>
                  <TableHeaderCell align="left" style={{ minWidth: 60 }}>
                  NGÀY TẠO	
                  </TableHeaderCell>

                  
                </TableRow>
              </TableHead>
              <TableBody>
                {rows &&
                    rows?.map((row, index) => (
                    <TableRow hover={true} key={index}>
                        <TableCell onClick={() => handleShowDetail(row)} align="left"> {index + 1}</TableCell>
                      <TableCell onClick={() => handleShowDetail(row)} align="left">{row?.lead?.phone}</TableCell>
                      <TableCell  onClick={() => handleShowDetail(row)} align="left"> {row?.lead?.fullname}</TableCell>
                      <TableCell onClick={() => handleShowDetail(row)} align="left">{row?.assigned_to &&
                            `${row?.assigned_to?.first_name} ${row?.assigned_to?.last_name}`}</TableCell>
                      <TableCell onClick={() => handleShowDetail(row)} align="left"> {moment(row?.created_on).format("MM/DD/YYYY")}</TableCell>
                      
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        <Typography>Dữ liệu chưa đồng bộ</Typography>
      )}
    </>
  )
}

export default TicketCustomer